module.exports = __webpack_public_path__ + "static/media/berrySmiling.4dcd7d67.svg";